var map = {
	"./Apple_Pay.svg": "ba33",
	"./amex.png": "7202",
	"./dinersclub.png": "348d",
	"./discover.png": "585b",
	"./gpay.png": "0f6d",
	"./jcb.png": "9f05",
	"./maestro.png": "66a5",
	"./mastercard.png": "29f0",
	"./visa.png": "1d74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b6d";